import {ReviewSentimentEnum, ReviewSentimentType} from '../../../../../../../../service/reviews/reviews-type';
import * as tagListStyles from '../../../../../tag-list/tag-list.scss';

export function getSentimentClassName(sentiment: string | null | undefined): string | null {
    switch (sentiment) {
        case ReviewSentimentEnum.negative:
            return tagListStyles.TagList_aspectNegative;
        case ReviewSentimentEnum.neutral:
            return tagListStyles.TagList_aspectNeutral;
        case ReviewSentimentEnum.positive:
            return tagListStyles.TagList_aspectPositive;
        default:
            return null;
    }
}

export function isReviewSentiment(value: string | null | undefined): value is ReviewSentimentType {
    return (
        value === ReviewSentimentEnum.positive ||
        value === ReviewSentimentEnum.neutral ||
        value === ReviewSentimentEnum.negative
    );
}
